import permissions from '../permissions'

const SUPPLIER_SUGGESTIONS_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.SUPPLIER_SUGGESTIONS.MANAGE,
  },
]

export default SUPPLIER_SUGGESTIONS_LIST
